module.exports = __webpack_public_path__ + "img/icon-home-active.776df630.svg";